// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SellerReviews__selfBlocked":"gu_a bhg_ea bhg_uy bhg_tq bhg_vk bhg_vf"};